<template>
	<div class="sf-flex-column h-100">
		<sf-data-table
			ref="mainTable"
			:pageUnit="pagingInfo.pageUnit"
			:totalSize="pagingInfo.totalSize"
			paging
			selection
			:columns="mainColumns"
			:rows="mainRows"
			fit="fit"
			:stripe="false"
			:excel="isButton_(scrId, 'EX')"
			@changedPage="changedPage"
		>
			<template v-slot:actionsLeft>
				<!-- 통지 -->
				<sf-button v-if="isButton_(scrId, 'CU') && isMmcAdmin" line icon="notice" :onClick="() => saveAction('infm')">
					{{ getMessage_('QWCC001553') }}
				</sf-button>
				<!-- 입고 -->
				<sf-button v-if="isButton_(scrId, 'CU') && (isMmcAdmin || isMmcManager)" line icon="export" :onClick="() => saveAction('whsn')">
					{{ getMessage_('QWCC001554') }}
				</sf-button>
			</template>
		</sf-data-table>
		<!-- pop up -->
		<popup-infm :scrId="scrId" ref="infmView" @Refresh="refresh"></popup-infm>
		<popup-whsn :scrId="scrId" ref="whsnView" @Refresh="refresh"></popup-whsn>
		<mes-info-popup ref="mesInfoPopup" @Refresh="refresh" :scrId="scrId"></mes-info-popup>
	</div>
</template>

<script>
import PopupInfm from '../PopupInfm/PopupInfm.vue';
import PopupWhsn from '../PopupWhsn/PopupWhsn.vue';
import MesInfoPopup from '@mmc/mmcm/MesInfo/Content/Popup/MesInfoPopup.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PopupInfm, MesInfoPopup, PopupWhsn },
	methods: {
		...rootMethods,
		...serviceMethods,
		clickMesEqipNo(row) {
			this.$refs.mesInfoPopup.open(row);
		},
		async onDownloadFile(fileId) {
			await this.fileDownload_({ fileId, fileSeq: 1 });
		},
		saveAction(param) {
			try {
				const mainTableRows = this.$refs.mainTable.getSelectedRows();
				if (!mainTableRows.length) {
					throw new Error(this.getMessage_('QWCC001556')); //선택한 행이 없습니다.
				}
				if (param === 'infm') this.infm(mainTableRows);
				if (param === 'whsn') this.whsn(mainTableRows);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		infm(mainTableRows) {
			/** 통지 팝업 초기화 */
			const value = [...mainTableRows].map(el => {
				el.infm = '';
				el.user1Yn = '';
				el.user2Yn = '';
				return el;
			});
			this.setState_({ key: 'infmResultList', value });
			this.$refs.infmView.open();
		},
		whsn(mainTableRows) {
			/** 입고 팝업 초기화 */
			const value = [...mainTableRows].map(el => {
				if (el.calStCd === 'INFM' || el.calStCd === 'RGST') {
					el.whsn = '';
					el.calInstCd = '';
					el.whsnDd = '';
					el.whsnDt = '';
				}
				return el;
			});
			this.setState_({ key: 'whsnResultList', value });
			this.$refs.whsnView.open();
		},
		refresh() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		mainRows() {
			return this.resultList;
		},
		mainColumns() {
			return [
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '90px',
					highlight: true,
					clickEvent: this.clickMesEqipNo
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('QWCC001318'), //제조사
					prop: 'mkrNm',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC001319'), //모델명
					prop: 'mdlNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001347'), //교정비용
					prop: 'calExp',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001320'), //시리얼번호
					prop: 'eqipSn',
					minWidth: '99px'
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptNm',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Id',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Nm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001647'), //교정완료일
					prop: 'calCmplDd',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001345'), //교정결과
					prop: 'calRsltCd',
					minWidth: '60px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calRsltCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC002024'), //교정보고서
					prop: 'calWrptYn',
					minWidth: '80px',
					form: {
						type: 'select',
						options: this.ynCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001628'), //성적서
					prop: 'rslrFileId',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001323'), //교정주기
					prop: 'calCyclCd',
					minWidth: '60px',
					form: {
						type: 'select',
						options: this.calCyclCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001324'), //차기교정일
					prop: 'nextCalDd',
					minWidth: '90px'
				},
				// {
				// 	label: this.getMessage_('QWCC001325'), //교정방식
				// 	prop: 'calWayCd',
				// 	minWidth: '70px',
				// 	form: {
				// 		type: 'select',
				// 		placeholder: ' - ',
				// 		options: this.calWayCdList,
				// 		isDisabled: () => true // 에디트 방지
				// 	}
				// },
				{
					label: this.getMessage_('QWCC001316'), //교정상태
					prop: 'calStCd',
					minWidth: '60px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calStCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '60px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.runStCdList,
						isDisabled: () => true // 에디트 방지
					}
				}
			];
		}
	}
};
</script>
